import { render } from "./IconNoPhoto.vue?vue&type=template&id=64899e62"
import script from "./IconNoPhoto.vue?vue&type=script&lang=js"
export * from "./IconNoPhoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__